var map = {
	"./category/index.vue": 1129,
	"./config/index.vue": 3542,
	"./config/inviterule/index.vue": 5519,
	"./config/pointsrule/index.vue": 3585,
	"./config/recharge/index.vue": 4772,
	"./config/signrule/index.vue": 7504,
	"./config/storenotice/index.vue": 1286,
	"./config/todayactivity/index.vue": 6896,
	"./config/wificonfig/index.vue": 2409,
	"./coupon/couponrecord/index.vue": 7509,
	"./coupon/coupontype/index.vue": 632,
	"./coupon/index.vue": 3227,
	"./desktop/index.vue": 134,
	"./finance/billrecord/index.vue": 4481,
	"./finance/coinsrecord/index.vue": 4452,
	"./finance/index.vue": 9278,
	"./finance/pointsrecord/index.vue": 750,
	"./goods/index.vue": 9447,
	"./member/benefitlist/index.vue": 6590,
	"./member/index.vue": 7723,
	"./member/levelrule/index.vue": 9599,
	"./member/memberlist/index.vue": 1982,
	"./order/index.vue": 9679,
	"./test/index.vue": 9639,
	"./workbench/index.vue": 2012
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 6010;